import "./SideBar.css"

import { House } from "lucide-react"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { BsQuestionSquare } from "react-icons/bs"
import {
  FaArrowLeftLong,
  FaInstagram,
  FaSquareFacebook,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa6"
import { GrLinkedin } from "react-icons/gr"
import { IoDocumentTextOutline } from "react-icons/io5"
import { RiUserLine } from "react-icons/ri"
import { TbMessage2 } from "react-icons/tb"
import { Link } from "react-router-dom"

import SideBarItem from "@/components/SideBar/SideBarItem/SideBarItem"
import { useFeedbacksCount, useSettingsData } from "@/queries/queries"
import { coursesIcon } from "@/utils/variables"
import { useStore } from "@/zustand/store"
import { useFreeMaterialData } from "../../queries/queries/freeMaterialsQueries"

export default function SideBar() {
  const { sideBarOpen, setSideBarOpen } = useStore((state) => state)
  const { t, i18n } = useTranslation()

  const settingsQuery = useSettingsData()
  const image = useMemo(() => {
    if (!settingsQuery?.data?.length) return ""
    return settingsQuery?.data?.find((ele) => ele?.key === "logo_student")
      ?.value
  }, [settingsQuery?.data])

  const { data: feedbacksCount } = useFeedbacksCount()
  const freeMaterialsQuery = useFreeMaterialData()

  return (
    // <nav
    //   className={`sidebar ramadan-bg-primary start-0 ${sideBarOpen ? "close" : ""}`}
    // >
    <nav className={`sidebar start-0 ${sideBarOpen ? "close" : ""}`}>
      <div
        style={i18n.language === "ar" ? { left: "-20px" } : { right: "-20px" }}
        className={`nav-toggel ${sideBarOpen ? "open" : ""}`}
        onClick={setSideBarOpen}
      >
        <span
          style={
            i18n.language === "ar"
              ? { transform: sideBarOpen ? "rotate(0deg)" : "rotate(180deg)" }
              : { transform: sideBarOpen ? "rotate(180deg)" : "rotate(0deg)" }
          }
        >
          <FaArrowLeftLong color="black" />
        </span>
      </div>

      <Link className="nav__logo" to="/">
        {!sideBarOpen && <img src={image} alt="logo" />}
      </Link>
      <div className="nav__list d-flex flex-column gap-3 overflow-auto">
        <SideBarItem icon={<House />} title={t("sidebar.home")} route="/" />
        <SideBarItem
          icon={<RiUserLine />}
          title={t("sidebar.profile")}
          route="/profile"
        />

        <SideBarItem
          icon={coursesIcon}
          title={t("sidebar.enrolledCourses")}
          route="/enrolled"
        />
        <SideBarItem
          icon={<BsQuestionSquare />}
          title={t("sidebar.projects")}
          route="/projects"
        />
        <SideBarItem
          icon={taskIcon}
          title={t("sidebar.feedbacks")}
          route="/feedbacks"
          count={feedbacksCount?.unReadFeedbacks}
        />
        <SideBarItem
          icon={<IoDocumentTextOutline />}
          title={t("sidebar.freeMaterials")}
          route="free-materials"
          isNew={!!freeMaterialsQuery?.data?.data?.length}
        />
        <SideBarItem
          icon={<TbMessage2 />}
          title={t("sidebar.tickets")}
          route="tickets"
        />
        <SideBarItem
          icon={surveysIcon}
          title={t("sidebar.survey")}
          route="surveys"
        />
      </div>
      <div style={{ height: "52px" }}>
        {!sideBarOpen && (
          <div className="d-flex justify-content-between px-3 py-3">
            <a
              target="_blank"
              style={{ color: "white" }}
              href={
                settingsQuery?.data?.find((el) => el.key === "linkedin")?.value
              }
              rel="noreferrer"
            >
              <GrLinkedin size={"24"} />
            </a>
            <a
              target="_blank"
              style={{ color: "white" }}
              href={
                settingsQuery?.data?.find((el) => el.key === "facebook")?.value
              }
              rel="noreferrer"
            >
              <FaSquareFacebook size={"24"} />
            </a>
            <a
              target="_blank"
              style={{ color: "white" }}
              href={
                settingsQuery?.data?.find((el) => el.key === "youtube")?.value
              }
              rel="noreferrer"
            >
              <FaYoutube size={"24"} />
            </a>
            <a
              target="_blank"
              style={{ color: "white" }}
              href={
                settingsQuery?.data?.find((el) => el.key === "instagram")?.value
              }
              rel="noreferrer"
            >
              <FaInstagram size={"24"} />
            </a>
            <FaTiktok size={"24"} />
          </div>
        )}
      </div>
    </nav>
  )
}

const taskIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_368_7869)">
      <path
        d="M8.80005 1.33333H8.68605C8.41072 0.557333 7.66938 0 6.80005 0H5.46672C4.59738 0 3.85605 0.557333 3.58072 1.33333H3.46672C1.99605 1.33333 0.800049 2.52933 0.800049 4V12.6667C0.800049 14.5047 2.29538 16 4.13338 16H8.13338C9.97138 16 11.4667 14.5047 11.4667 12.6667V4C11.4667 2.52933 10.2707 1.33333 8.80005 1.33333ZM10.1334 12.6667C10.1334 13.7693 9.23605 14.6667 8.13338 14.6667H4.13338C3.03072 14.6667 2.13338 13.7693 2.13338 12.6667V4C2.13338 3.26467 2.73138 2.66667 3.46672 2.66667H4.13338C4.50205 2.66667 4.80005 2.36867 4.80005 2C4.80005 1.63133 5.09872 1.33333 5.46672 1.33333H6.80005C7.16805 1.33333 7.46672 1.632 7.46672 2C7.46672 2.368 7.76472 2.66667 8.13338 2.66667H8.80005C9.53538 2.66667 10.1334 3.26467 10.1334 4V12.6667ZM14.8 0C13.6974 0 12.8 0.897333 12.8 2V12.8953C12.8 13.786 13.1474 14.6233 13.7767 15.2527L14.3287 15.8047C14.4587 15.9347 14.6294 16 14.8 16C14.9707 16 15.1414 15.9347 15.2714 15.8047L15.8234 15.2527C16.4527 14.6233 16.8 13.786 16.8 12.8953V2C16.8 0.897333 15.9027 0 14.8 0ZM15.4667 12.8953C15.4667 13.43 15.258 13.9327 14.8807 14.31L14.8 14.3907L14.7194 14.31C14.342 13.9327 14.1334 13.43 14.1334 12.8953V2C14.1334 1.632 14.432 1.33333 14.8 1.33333C15.168 1.33333 15.4667 1.632 15.4667 2V12.8953ZM7.28472 4.52867C7.54538 4.78933 7.54538 5.21067 7.28472 5.47133L5.83205 6.924C5.55938 7.19667 5.20138 7.33267 4.84338 7.33267C4.48538 7.33267 4.12738 7.19667 3.85472 6.924L2.99605 6.06467C2.73538 5.804 2.73538 5.382 2.99605 5.122C3.25672 4.86133 3.67805 4.86133 3.93872 5.122L4.79738 5.98133C4.81938 6.00333 4.86738 6.00333 4.89005 5.98133L6.34272 4.52867C6.60338 4.268 7.02405 4.268 7.28472 4.52867ZM7.28472 8.52867C7.54538 8.78933 7.54538 9.21067 7.28472 9.47133L5.83205 10.924C5.55938 11.1967 5.20138 11.3327 4.84338 11.3327C4.48538 11.3327 4.12738 11.1967 3.85472 10.924L2.99605 10.0647C2.73538 9.804 2.73538 9.382 2.99605 9.122C3.25672 8.86133 3.67805 8.86133 3.93872 9.122L4.79738 9.98133C4.81938 10.0033 4.86738 10.0033 4.89005 9.98133L6.34272 8.52867C6.60338 8.268 7.02405 8.268 7.28472 8.52867Z"
        fill="#ffffff"
      />
    </g>
    <defs>
      <clipPath id="clip0_368_7869">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.800049)"
        />
      </clipPath>
    </defs>
  </svg>
)

const surveysIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <circle fill="#fff" cx="7" cy="10" r="1"></circle>{" "}
      <circle fill="#fff" cx="7" cy="14" r="1"></circle>{" "}
      <circle fill="#fff" cx="7" cy="18" r="1"></circle>{" "}
      <path
        fill="#fff"
        d="M17.075 11H11.04c-.552 0-1-.448-1-1s.448-1 1-1h6.035c.553 0 1 .448 1 1s-.447 1-1 1zM17.075 15H11.04c-.552 0-1-.448-1-1s.448-1 1-1h6.035c.553 0 1 .448 1 1s-.447 1-1 1zM17.075 19H11.04c-.552 0-1-.447-1-1s.448-1 1-1h6.035c.553 0 1 .447 1 1s-.447 1-1 1z"
      ></path>{" "}
      <path
        fill="#fff"
        d="M20 2h-3c0-1.1-.9-2-2-2H9C7.9 0 7 .9 7 2H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 3.5v-1c0-.276.224-.5.5-.5h5c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5h-5c-.276 0-.5-.224-.5-.5zm11 18v.003c-.003.275-.225.497-.5.497H4.515l-.015.003c-.276 0-.5-.224-.5-.5V4.5c0-.276.224-.5.5-.5H7c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2h2.5c.277 0 .5.224.5.5v17z"
      ></path>{" "}
    </g>
  </svg>
)
